import { render, staticRenderFns } from "./PromotionTips.vue?vue&type=template&id=638ee2eb"
import script from "./PromotionTips.vue?vue&type=script&lang=js"
export * from "./PromotionTips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports